import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { Routes } from './app/router/Routes';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import theme from './app/styles/theme';
import { CustomProvider } from 'rsuite';

export default function App ({ store, persistor, basename }) {
    return (
        /* Provide Redux store */
        <Provider store={store}>
            {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
            <PersistGate persistor={persistor}>
                {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
                {/* <React.Suspense fallback={<LayoutSplashScreen />}> */}
                {/* Override `basename` (e.g: `homepage` in `package.json`) */}
                <BrowserRouter basename={basename}>
                    {/* This library only returns the location that has been active before the recent location change in the current window lifetime. */}
                    <LastLocationProvider>
                        {/* Render routes with provided `Layout`. */}
                        <StyledEngineProvider injectFirst>
                            <ThemeProvider theme={theme}>
                                <CustomProvider>
                                    <Routes />
                                </CustomProvider>
                            </ThemeProvider>
                        </StyledEngineProvider>
                    </LastLocationProvider>
                </BrowserRouter>
                {/* </React.Suspense> */}
            </PersistGate>
        </Provider>
    );
}
